import * as React from 'react';
import { SVGProps } from 'react';

const IconPrinterStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3v3H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v4H4V8h16v8h-2v2h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1Zm2 1v2h8V4H8Zm0 16v-7h8v7H8Z"
    />
  </svg>
);
export default IconPrinterStrokedSizeM;
